import { AnyAppEvent, AppEvent } from "../../appEvent.types";
import { z } from "zod";

const eventName = "open-exponent-socials" as const;

export const OpenExponentSocialsEventDataSchema = z.object({
  structureId: z.string(),
  eventId: z.string(),
});

export type OpenExponentSocialsEventData = z.infer<
  typeof OpenExponentSocialsEventDataSchema
>;

export type OpenExponentSocialsEvent = AppEvent<
  typeof eventName,
  OpenExponentSocialsEventData
>;

export const isOpenExponentSocialsEvent = (
  event: AnyAppEvent
): event is OpenExponentSocialsEvent => event.name === eventName;

export { eventName as openExponentSocials };
